import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import SEO from '../../components/SEO/SEO';
import './Legal.css';

function TermsOfUse() {
  const { t } = useTranslation();

  return (
    <div className="legal">
      <SEO
        title="Terms of Use — Unimar Boats"
        description="Review the terms and conditions governing your use of the Unimar website and services."
        url="/terms-of-use"
      />
      <Header />

      <div className="legal__hero">
        <div className="legal__hero-overlay" />
        <div className="legal__hero-content">
          <h1 className="legal__hero-title">{t('termsOfUse.title')}</h1>
          <p className="legal__hero-sub">{t('termsOfUse.lastUpdated')}</p>
        </div>
      </div>

      <div className="legal__body">
        <div className="legal__inner">

          <section className="legal__section">
            <h2 className="legal__section-title">{t('termsOfUse.s1.heading')}</h2>
            <p className="legal__text">{t('termsOfUse.s1.p1')}</p>
            <p className="legal__text">{t('termsOfUse.s1.p2')}</p>
          </section>

          <section className="legal__section">
            <h2 className="legal__section-title">{t('termsOfUse.s2.heading')}</h2>
            <p className="legal__text">{t('termsOfUse.s2.intro')}</p>
            <ul className="legal__list">
              <li>{t('termsOfUse.s2.item1')}</li>
              <li>{t('termsOfUse.s2.item2')}</li>
              <li>{t('termsOfUse.s2.item3')}</li>
              <li>{t('termsOfUse.s2.item4')}</li>
              <li>{t('termsOfUse.s2.item5')}</li>
            </ul>
          </section>

          <section className="legal__section">
            <h2 className="legal__section-title">{t('termsOfUse.s3.heading')}</h2>
            <p className="legal__text">{t('termsOfUse.s3.p1')}</p>
            <p className="legal__text">{t('termsOfUse.s3.p2')}</p>
          </section>

          <section className="legal__section">
            <h2 className="legal__section-title">{t('termsOfUse.s4.heading')}</h2>
            <p className="legal__text">{t('termsOfUse.s4.p1')}</p>
            <p className="legal__text">{t('termsOfUse.s4.p2')}</p>
          </section>

          <section className="legal__section">
            <h2 className="legal__section-title">{t('termsOfUse.s5.heading')}</h2>
            <p className="legal__text">{t('termsOfUse.s5.p1')}</p>
            <p className="legal__text">{t('termsOfUse.s5.p2')}</p>
          </section>

          <section className="legal__section">
            <h2 className="legal__section-title">{t('termsOfUse.s6.heading')}</h2>
            <p className="legal__text">{t('termsOfUse.s6.p1')}</p>
            <p className="legal__text">{t('termsOfUse.s6.p2')}</p>
          </section>

          <section className="legal__section">
            <h2 className="legal__section-title">{t('termsOfUse.s7.heading')}</h2>
            <p className="legal__text">{t('termsOfUse.s7.p')}</p>
          </section>

          <section className="legal__section">
            <h2 className="legal__section-title">{t('termsOfUse.s8.heading')}</h2>
            <p className="legal__text">{t('termsOfUse.s8.p')}</p>
          </section>

          <section className="legal__section">
            <h2 className="legal__section-title">{t('termsOfUse.s9.heading')}</h2>
            <p className="legal__text">{t('termsOfUse.s9.p')}</p>
          </section>

          <section className="legal__section">
            <h2 className="legal__section-title">{t('termsOfUse.s10.heading')}</h2>
            <p className="legal__text">{t('termsOfUse.s10.p')}</p>
          </section>

          <section className="legal__section">
            <h2 className="legal__section-title">{t('termsOfUse.s11.heading')}</h2>
            <p className="legal__text">
              {t('termsOfUse.s11.p')}<br />
              Email: <a href="mailto:info@unimar.com" className="legal__link">info@unimar.com</a>
            </p>
          </section>

        </div>
      </div>

      <Footer />
    </div>
  );
}

export default TermsOfUse;
